module.exports = __webpack_public_path__ + "static/media/no.6f56cf03.mp3";